module.exports = __webpack_public_path__ + "img/product-xjg-3512.fcefec48.png";